<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:35:17
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id='refund'>
                <div id='main-container' class="main-container">
                    <van-notice-bar mode="closeable" class='barStyle' v-if='dataRefund.orderStatus === orderStatus.pendingReceipt || dataRefund.orderStatus === orderStatus.comment || dataRefund.orderStatus === orderStatus.completde'>
                        温馨提示：待发货或者待收货（未收到货）的订单，只能发起全部订单商品的退货/退款；
                    </van-notice-bar>
                    <div class='refundGood'>
                        <h4>
                            <span>退货商品</span>
                        </h4>
                        <div class='refundGoodsList'>
                            <van-row>
                                <van-col span="6" class='GoodInfo' v-for='item in dataRefund.refundOrderItemList' :key='item.id'>
                                    <img :src="item.productImg" alt="">
                                    <p>¥{{ESVBase.numberTofixed(item.productPrice)}}</p>
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                    <div class='refundStatus'>
                        <van-cell-group>
                            <van-cell title="退款原因" :value="refundReasonTitle" is-link @click='changeType === true || type === "2" ? refundReasonShow = true : refundReasonShow = false' />

                        </van-cell-group>
                    </div>
                    <div class='refundNum'>
                        <van-cell-group>
                            <van-cell title="商品件数：" :value="valueNum" value-class="value-cell" />
                            <van-cell title="退款金额：" :value="'¥' + dataRefund.refundAmount"
                            value-class="refund-cell" />
                        </van-cell-group>

                    </div>
                    <div class='refundyf'>
                        <p>最多¥{{ESVBase.numberTofixed(dataRefund.refundAmount)}}，含发货邮费¥{{dataRefund.freightAmount !== undefined && dataRefund.freightAmount !== 0 ? ESVBase.numberTofixed(dataRefund.freightAmount) : 0}}</p>
                    </div>
                    <div class='refundExplain'>
                        <van-cell-group>
                            <van-field v-model="refundExplain" label="退款说明：" type="textarea" placeholder="请输入说明" rows="1" autosize />
                        </van-cell-group>
                    </div>
                    <div class='refundUpload'>
                        <es-photo-album
                            :title="title"
                            :label="label"
                            :data-source="dataSource"
                            :is-disabled="isDisabled"
                            :max-count="maxCount"
                            :other-data="otherData"
                            :origin="origin"
                            :save="save"
                            :size-type="sizeType"
                        />
                    </div>

                </div>
                <div class='submitBtn'>
                    <van-button round type="danger" @click='submitClick'>提交</van-button>
                </div>
                <van-popup v-model="statusShow" position="bottom" :overlay="true">
                    <div class='refundReason'>
                        <h5>货物状态</h5>
                        <van-radio-group v-model="radioGoodsName" @change='radioGoodsTypeClick'>
                            <van-cell-group>
                                <van-cell :title="item.title" v-for='item in productStatusData' :key='item.type' clickable @click="radioGoodsTypeClick(item.type + '/'+item.title)">
                                    <van-radio :name="item.type + '/'+item.title" />
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                        <div class='refundReasonBtn'>
                            <van-button round type="danger" @click='statusShow = false'>关 闭</van-button>
                        </div>
                    </div>
                </van-popup>
                <van-popup v-model="refundReasonShow" position="bottom" :overlay="true">
                    <div class='refundReason radio-wrapper'>
                        <h5>退款原因</h5>
                        <van-radio-group v-model="reasonradio" @change="reasonClick">
                            <van-cell-group class='cellGroup'>
                                <van-cell :title="item.title" v-for='item in weekreceivedReason' :key='item.type' clickable @click="reasonClick(item.title)" @change="reasonClick">
                                    <van-radio :name="item.title" />
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                        <div class='refundReasonBtn'>
                            <van-button round type="danger" @click='refundReasonShow = false'>关 闭</van-button>
                        </div>
                    </div>
                </van-popup>
                <van-popup v-model="exchangeShow" position="bottom" :overlay="true">
                    <div class='refundReason'>
                        <h5>换货原因</h5>
                        <van-radio-group v-model="radio">
                            <van-cell-group>
                                <van-cell :title="item.title" clickable @click="changeReason(item)" v-for='item in changeProductData' :key='item.type'>
                                    <van-radio :name="item.name" />
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                        <div class='refundReasonBtn'>
                            <van-button round type="danger" @click='exchangeShow = false'>关 闭</van-button>
                        </div>
                    </div>
                </van-popup>
            </div>
        </div>
    </div>
</template>
<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import * as orderStatus from '@/assets/js/const.js';
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
    data() {
        return {
            orderStatus: { ...orderStatus },
            title: '上传凭证',
            label: '',
            dataSource: [],
            isDisabled: false,
            maxCount: 3,
            otherData: {},
            origin: ['camera', 'album'],
            save: true,
            sizeType: 'default',
            // 货物状态
            goodsTypeTitle: '',
            refundReasonTitle: '',
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            valueNum: 5,
            value: {},
            refundExplain: '',
            ExchangeExplain: '',
            message: '',
            radioGoodsName: '',
            productStatusData: [
                {
                    name: '1',
                    type: '1',
                    title: '未收到货'
                },
                {
                    name: '2',
                    type: '2',
                    title: '已收到货'
                }
            ],
            urlData: [
                {
                    name: '上传凭证',
                    type: 8,
                    enName: 'environmentPhoto',
                    fieldLength: 3
                }
            ],
            refundOnlyReason: [
                {
                    name: '1',
                    type: '1',
                    title: '我不想买'
                },
                {
                    name: '2',
                    type: '2',
                    title: '收货地址填写有误'
                }
            ],
            notReceivedReason: [
                {
                    name: '1',
                    type: '1',
                    title: '不喜欢/不想要'
                },
                {
                    name: '2',
                    type: '2',
                    title: '空包裹'
                },
                {
                    name: '3',
                    type: '3',
                    title: '未按约定时间发货'
                },
                {
                    name: '4',
                    type: '4',
                    title: '快递/物流一直未送到'
                },
                {
                    name: '5',
                    type: '5',
                    title: '快递/物流无跟踪记录'
                },
                {
                    name: '6',
                    type: '6',
                    title: '货物破损已拒签'
                }
            ],
            receivedReason: [
                {
                    name: '1',
                    type: '1',
                    title: '退运费'
                },
                {
                    name: '2',
                    type: '2',
                    title: '颜色/尺寸/参数不符'
                },
                {
                    name: '3',
                    type: '3',
                    title: '商品瑕疵'
                },
                {
                    name: '4',
                    type: '4',
                    title: '质量问题'
                },
                {
                    name: '5',
                    type: '5',
                    title: '少件/漏发'
                },
                {
                    name: '6',
                    type: '6',
                    title: '收到商品时有划痕或破损'
                },
                {
                    name: '7',
                    type: '7',
                    title: '未按约定时间发货'
                },
                {
                    name: '8',
                    type: '8',
                    title: '发票问题'
                }
            ],
            weekreceivedReason: [
                {
                    name: '1',
                    type: '1',
                    title: '7天无理由'
                },
                {
                    name: '2',
                    type: '2',
                    title: '退运费'
                },
                {
                    name: '3',
                    type: '3',
                    title: '颜色/尺寸/参数不符'
                },
                {
                    name: '4',
                    type: '4',
                    title: '商品瑕疵'
                },
                {
                    name: '5',
                    type: '5',
                    title: '质量问题'
                },
                {
                    name: '6',
                    type: '6',
                    title: '少件/漏发'
                },
                {
                    name: '7',
                    type: '7',
                    title: '收到商品时有划痕或破损'
                },
                {
                    name: '8',
                    type: '8',
                    title: '假冒品牌'
                },
                {
                    name: '9',
                    type: '9',
                    title: '未按约定时间发货'
                },
                {
                    name: '10',
                    type: '10',
                    title: '发票问题'
                }
            ],
            changeProductData: [
                {
                    type: '1',
                    name: '1',
                    title: '7天无理由换货'
                }
            ],
            statusShow: false,
            refundReasonShow: false,
            exchangeShow: false,
            radio: '1',
            reasonradio: '0',
            radioGoodsType: '',
            dataRefund: { refundOrderItemList: [] },
            type: '',
            goodStatus: '',
            // 已填写的数据
            completedData: {},
            changeType: false
        };
    },
    mounted() {},

    esvReady() {
        document.title = '退款';
        this.ESVStorage.getSavedValue('status', (data) => {
            this.status = data;
            console.log(data);
        });
    },
    esvShow() {
        this.queryMemberOrderItemForRefund(this.dataDetails.memberOrderItemList);
        const ths = this;
        this.ESVStorage.getSavedValue('completedData', (data) => {
            ths.completedData = data;
        });
        this.radioGoodsType = this.completedData.radioGoodsType;
        this.reasonradio = this.completedData.reasonradio;
        // this.valueNum = this.completedData.valueNum;
        this.refundExplain = this.completedData.refundExplain;
        this.value = this.completedData.value || {};
        this.refundReasonTitle = this.completedData.refundReasonTitle || '';
        this.goodsTypeTitle = this.completedData.goodsTypeTitle || '';

        this.type = this.$route.query.type;

        if (this.completedData.changeType !== undefined) {
            this.changeType = this.completedData.changeType;
        }
        this.ESVStorage.removeSavedValue('completedData');
    },
    computed: {
        ...mapState({
            dataDetails: state => state.order.orderDetails
        }),
        ...mapGetters([
            'merchantInfoSwitch'
        ]),
        refundReason() {
            return this.dataRefund.orderStatus === orderStatus.toDeliver || this.dataRefund.orderStatus === orderStatus.pendingReceipt || this.dataRefund.orderStatus === orderStatus.comment || this.dataRefund.orderStatus === orderStatus.completde && this.type === '1' || this.type === '2';
        },
        goodsStatusShow() {
            return this.dataRefund.orderStatus === this.orderStatus.pendingReceipt && this.type === '1' || this.dataRefund.orderStatus === orderStatus.comment && this.type === '1' || this.dataRefund.orderStatus === this.orderStatus.completde && this.type === '1';
        },
        refundQuantityShow() {
            return (
                this.dataRefund.orderStatus === this.orderStatus.toDeliver ||
                this.dataRefund.orderStatus === this.orderStatus.comment ||
                this.dataRefund.orderStatus === this.orderStatus.completde
            ) && (this.radioGoodsType === '2' || this.type === '2');
        }
    },
    watch: {
        dataRefund: {
            // 深度监听，可监听到对象、数组的变化
            handler(val, oldVal) {
                console.log('b.c: ' + val, oldVal); // 但是这两个值打印出来却都是一样的
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations(['changeOrderDetails']),
        queryMemberOrderItemForRefund(item) {
            const ths = this;
            const params = {
                orderCode: item[0].orderCode,
                merchantInfo: JSON.stringify(this.merchantInfoSwitch)
            };
            ths.$doRequest(
                {
                    url: '/refund/queryMemberOrderItemForRefund',
                    params: params,
                    complete: function() {}
                },
                function(data) {
                    const orderStatus = data.result.orderStatus;
                    ths.dataRefund = data.result;
                    ths.valueNum = ths.dataRefund.refundOrderItemList[0].quantity;
                    ths.dataRefund.orderStatus === orderStatus.toDeliver
                        ? (ths.changeType = true)
                        : (ths.changeType = false);
                    // ths.ESVStorage.getSavedValue('status', (data) => {
                    //     console.log('save', data, orderStatus);

                    //     if (data !== orderStatus) {
                    //         ths.ESVStorage.putSavedValue(
                    //             'oldStatus',
                    //             'all'
                    //         );
                    //         ths.ESVStorage.putSavedValue(
                    //             'status',
                    //             orderStatus
                    //         );
                    //     }
                    //     // if (type === ths.orderStatus.pendingReceipt || type === ths.orderStatus.comment || type === ths.orderStatus.completde) {
                    //     //     ths.esvOpenPage('OPChoiceRefundType');
                    //     // }
                    // });
                }
            );
        },
        changeReason(item) {
            this.radio = item.name;
            this.exchangeShow = false;
        },
        changeStatus(name) {
            this.changeType = true;
            this.refundReasonTitle = '';
            this.reasonradio = '';
            if (name === '1') {
            } else {
            }
        },
        submitClick() {
            const ths = this;
            if ((ths.dataRefund.orderStatus === orderStatus.pendingReceipt && ths.type === '1') || (ths.dataRefund.orderStatus === orderStatus.comment && ths.type === '1') || (ths.dataRefund.orderStatus === orderStatus.completde && ths.type === '1')) {
                if (this.goodsTypeTitle.length <= 0) {
                    ths.$toast('货物状态不能为空');
                    return false;
                }
            }
            if ((ths.dataRefund.orderStatus === orderStatus.pendingReceipt || ths.dataRefund.orderStatus === orderStatus.pendingReceipt || ths.dataRefund.orderStatus === orderStatus.comment || ths.dataRefund.orderStatus === orderStatus.completde) && (ths.type === '1' || ths.type === '2')) {
                if (this.refundReasonTitle.length <= 0) {
                    ths.$toast('退换原因不能为空');
                    return false;
                }
            }

            let refundCode = '';
            const photo = ths.dealPhoto(ths.dataSource);
            const refundJsonList = [];
            this.dataRefund.refundOrderItemList.forEach((item, index) => {
                if (
                    ths.dataRefund.refundOrderItemList.length <= 1 &&
                    (ths.dataRefund.orderStatus === orderStatus.pendingReceipt || ths.dataRefund.orderStatus === orderStatus.comment || ths.dataRefund.orderStatus === orderStatus.completde) &&
                    (ths.radioGoodsType === '2' || ths.type === '2')
                ) {
                    refundJsonList.push({
                        productId: item.productId,
                        skuCode: item.skuCode,
                        quantity: ths.valueNum
                    });
                } else {
                    refundJsonList.push({
                        productId: item.productId,
                        skuCode: item.skuCode,
                        quantity: item.retreatQuantity
                    });
                }
            });
            if (ths.dataRefund.orderStatus === orderStatus.toDeliver) {
                ths.radioGoodsType = '1';
            }
            if (ths.dataRefund.orderStatus === orderStatus.pendingReceipt || ths.dataRefund.orderStatus === orderStatus.comment || ths.dataRefund.orderStatus === orderStatus.completde) {
                if (ths.type === '2') {
                    ths.radioGoodsType = '2';
                }
            }
            const params = {
                orderCode: ths.dataRefund.refundOrderItemList[0].orderCode,
                // type: ths.type,
                goodStatus: ths.radioGoodsType,
                reason: ths.refundReasonTitle,
                desc: ths.refundExplain,
                certificate: photo,
                merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                // refundJsonList: JSON.stringify(refundJsonList)
            };
            ths.$doRequest(
                {
                    url: '/refund/refundApplication',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                (data) => {
                    refundCode = data.result.refundCode;
                    this.changeOrderDetails({ statusName: 'lockFlag', status: 1 });
                    ths.queryMemberOrderRefund(refundCode);
                }
            );
        },
        queryMemberOrderRefund(refundCode) {
            const ths = this;
            const params = {
                refundCode: refundCode
            };
            ths.$doRequest(
                {
                    url: '/refund/queryMemberOrderRefund',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.ESVStorage.putSavedValue(
                        'refundSuccessData',
                        data.result
                    );
                    ths.esvReloadPage('OPReturnGoodsDetails');
                }
            );
        },
        // 处理图片数据
        dealPhoto(photoObj) {
            const newPhone = [];
            if (photoObj) {
                if (photoObj) {
                    // 表示新增的数据
                    photoObj.forEach((item, index) => {
                        newPhone.push(item.photoUrl);
                    });
                } else {
                    // Sting类型的表示编辑的数据
                    return photoObj;
                }
            }
            return newPhone.join(',');
        },
        // 改变数量渲染金额
        changeNumFn(num) {
            const ths = this;
            const orderItemJsonList = [];

            ths.dataRefund.refundOrderItemList.forEach(
                (value, index, array) => {
                    orderItemJsonList.push({
                        productId: value.productId,
                        skuCode: value.skuCode,
                        quantity: ths.valueNum
                    });
                }
            );

            const params = {
                orderCode: ths.dataRefund.refundOrderItemList[0].orderCode
            };
            ths.$doRequest(
                {
                    url: '/refund/queryMemberOrderItemForRefund',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.dataRefund = data.result;
                }
            );
        },
        radioGoodsTypeClick(typeAndTitle) {
            // this.radioGoodsName = type + '/' + title;

            this.radioGoodsName = typeAndTitle;
            const strArr = this.radioGoodsName.split('/');
            this.radioGoodsType = strArr[0];
            this.changeStatus(this.radioGoodsType);
            this.goodsTypeTitle = strArr[1];
            this.statusShow = false;
        },
        reasonClick(title) {
            console.log(title);
            this.reasonradio = title;
            this.refundReasonTitle = title;
            this.refundReasonShow = false;
        },
        groupChange(name) {
            console.log(name);
        },
        openChoose() {
            this.ESVStorage.putSavedValue('completedData', {
                radioGoodsType: this.radioGoodsType,
                reasonradio: this.reasonradio,
                valueNum: this.valueNum,
                refundExplain: this.refundExplain,
                value: this.value,
                goodsTypeTitle: this.goodsTypeTitle,
                changeType: this.changeType,
                refundReasonTitle: this.refundReasonTitle
            });
            this.esvOpenPage({ name: 'OPChoiceGood', query: this.$route.query });
        },
        openAddress() {
            this.esvOpenPage('OPChoiceAddress');
        }
    }
};
</script>
<style lang="scss" scoped>
#main-container {
    max-height: 100vh;
}
#refund {

    .refundGood {
        background: #fff;
        padding: 12px;
        h4 {
            font-weight: 500;
            padding-bottom: 12px;
            border-bottom: 1px solid #e3e2e2;
            font-size: 14px;
            overflow: hidden;
        }
        .GoodInfo {
            position: relative;
            text-align: center;
            display: flex;
            img {
                width: 90px;
                height: 90px;
            }
            p {
                background: rgba(0, 0, 0, 0.5);
                color: white;
                text-align: center;
                height: 24px;
                line-height: 24px;
                position: absolute;
                bottom: 0;
                width: 90px;
            }
        }
        .refundGoodsList {
            padding: 12px 0;
        }
    }
    .refundStatus {
        margin-top: 12px;
    }
    .refundNum {
        margin-top: 12px;
    }
    .refundyf {
        padding: 12px;
        color: #999;
    }
    .refundUpload {
        margin-top: 12px;
        margin-bottom: 60px;
        padding: 5px 12px 10px 12px;
        background: #fff;
        /deep/ .van-cell-group{
            padding:0 12px;
            /deep/ .van-cell__value{
                span{
                    font-size:14px;
                }
            }
        }
        /deep/ .es-photo-album > span {
            font-size: 14px;
        }
    }
    .main-container {

    }
    .submitBtn {
        width: 100%;
        height: 60px;
        padding: 0;
        // background: #fff;
        text-align: center;
        line-height: 60px;
        position: fixed;
        bottom: 0;
        left: 0;
        .van-button {
            width: 80%;
        }
    }
    .refundReason {
        padding: 12px;
        h5 {
            text-align: center;
            padding: 10px 0;
            font-weight: 500;
            font-size: 16px;
        }
        .refundReasonBtn {
            text-align: center;
            line-height: 60px;
            width: 100%;
            height: 60px;
            .van-button {
                width: 80%;
                .van-button--danger {
                    background: #ee2e50;
                }
            }
        }
    }
    .chooseaddress {
        text-align: left;
        padding-left: 15px;
    }
    .barStyle {
        font-size: 12px;
    }
    .cellGroup {
        height: 300px;
        overflow-y: auto;
    }
    .radio-wrapper {
        /deep/ .van-radio-group {
            /deep/ .van-hairline--top-bottom::after {
                border-width: 0 !important;
            }
        }
    }
    .value-cell {
    }
    .refund-cell {
        color: #EE2E50 !important;
    }
}
</style>
